export default {
  selectLang: "選擇語言",
  footer: {
    copyright: "© 2025 TaxEcoBit。保留所有權利。",
    terms: "服務條款",
    privacy: "隱私政策",
    help: "需要幫助或建議？",
  },
  menu: {
    dashboard: "儀表板",
    calculate: "計算",
    calculations: "計算記錄",
    pricing: "價格",
    settings: "設定",
    factors: "係數",
    reports: "報告",
    upgrade: "升級",
    usage: "使用情況",
    invite: "邀請",
    home: "首頁",
    blog: "部落格",
    whitepaper: "白皮書",
    about: "關於我們",
    faq: "常見問題",
    terms: "服務條款",
    privacy: "隱私政策",
    tickets: "工單",
    billing: "帳單",
    "billing-overview": "概覽",
    "billing-orders": "訂單",
    "billing-invoices": "發票",
    "billing-subscription": "訂閱",
    templates: "模板",
  },
  upgradeWall: {
    successTitle: "試用申請成功",
    successSubtitle: "您已成功申請 14 天免費專業版試用",
    quotaTitle: "計算配額：",
    reportQuotaTitle: "報告配額：",
    planComparison: "方案功能對比",
    calculation: "計算",
    report: "報告",
    price: "價格",
    viewPricing: "查看完整價格",
    freeTrial: "14 天免費專業版試用",
    upgradeToPro: "升級到專業版",
    upgradePro: "升級專業版",
    contactSupport: "聯絡支援",
    inviteRewards: "透過邀請獲得更多配額！",
    inviteRewardsDesc: "邀請朋友註冊，您和朋友都能獲得額外計算配額",
    inviteFriends: "邀請朋友",
    quotaExhausted: "您的方案配額已用完",
    calculationThreshold: "您的計算配額已使用 {percent}%",
    reportThreshold: "您的報告配額已使用 {percent}%",
    upgradePlan: "升級方案",
    free: "免費",
    basic: "49 歐元/月",
    proPrice: "99 歐元/月",
    timesPerMonth: "次/月",
    plan: "方案",
    trialSuccess: "試用申請成功",
  },
  ticket: {
    modal_title: "提交工單",
  },
  brand: {
    what_is_taxecobit: "什麼是 TaxEcoBit？",
    taxecobit_description:
      "TaxEcoBit 是專為受歐盟碳邊境調整機制 (CBAM) 影響的企業設計的合規自動化平台。我們幫助進口商、製造商和中小企業計算產品特定的碳排放，生成符合 CBAM 的文件，並降低監管風險。",
    taxecobit_benefits: "使用 TaxEcoBit，用戶可以：",
    benefit_accurate_calculations: "使用官方和自訂排放係數進行精確的碳計算",
    benefit_cbam_documents: "生成符合 CBAM 的文件以供提交",
    benefit_carbon_cost_tracking: "監控碳成本影響並優化營運效率",
    benefit_api_integration: "通過 API 將合規工作流程與 ERP 和供應鏈系統無縫整合",
    taxecobit_conclusion:
      "通過取代手動電子表格計算和顧問依賴，TaxEcoBit 實現更快、更可靠的合規，降低營運成本。",
  },
  userLevel: {
    label: "用戶等級",
    highest_level: "最高等級",
    next_level: "下一等級：{level}",
    standard_user: "標準用戶",
    bronze_user: "青銅用戶",
    silver_user: "白銀用戶",
    gold_user: "黃金用戶",
    platinum_user: "白金用戶",
    bronze_next: "青銅（50 次計算）",
    silver_next: "白銀（150 次計算）",
    gold_next: "黃金（300 次計算）",
    platinum_next: "白金（600 次計算）",
    highest_level_text: "已達最高等級",
  },
  notification: {
    title: "通知",
    settings: "通知設定",
    preferences: "通知偏好",
    email_notifications: "電子郵箱通知",
    app_notifications: "應用程式通知",
    all: "所有通知",
    important: "僅重要通知",
    none: "無通知",
    save_preferences: "儲存通知偏好",
    success_message: "通知偏好儲存成功",
    error_message: "通知偏好儲存失敗",
    detail_title: "通知詳情",
    mark_as_read: "標記為已讀",
    not_found_title: "找不到通知",
    not_found_desc: "您查找的通知不存在或已被刪除。",
    search_placeholder: "按標題或內容搜尋",
    email_sent: "郵件已發送",
    in_app_only: "僅應用程式內",
    no_notifications: "無通知",
    total: "共 {total} 條通知",
    fetch_failed: "獲取通知失敗",
    marked_as_read: "標記為已讀成功",
    mark_failed: "標記為已讀失敗",
    mark_all_read: "全部標記為已讀",
    view_all: "查看全部",
  },
  notFound: {
    title: "404 找不到",
    description: "抱歉，您訪問的頁面不存在。",
    goHome: "回到首頁",
  },
  login: {
    sign_in: "登入",
    sign_up: "註冊",
    password_rule_length: "至少 8 個字元",
    password_rule_letter: "包含英文字母",
    password_rule_number: "包含數字",
    password_rule_special: "包含特殊字元 {0}",
  },
};
